<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleOfferte > 0"
      item-key="codice"
      :headers="headers"
      :items="offerteSorted"
      :options.sync="options"
      :server-items-length="totaleOfferte"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Offerte</v-toolbar-title>
<!--    <v-divider class="mx-4" inset vertical></v-divider> -->
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="onNuovoOfferta">Nuova Offerta</v-btn>
        <dialog-errore :show="dialogErrore" title="" />
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione offerta?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.attiva`]="{ item }">
      {{ item.attiva ? 'SI' : 'NO' }}
    </template>
    <template v-slot:[`item.dataDa`]="{ item }">
      {{ item.dataDa | dateNull }}
    </template>
    <template v-slot:[`item.dataA`]="{ item }">
      {{ item.dataA | dateNull }}
    </template>
    <template v-slot:[`item.quantitaMinima`]="{ item }">
      {{ item.quantitaMinima | dueDecimali }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
    <!-- <v-icon small class="mr-2" @click="duplicateItem(item)" title="Duplica il prodotto">mdi-content-duplicate</v-icon> -->
      <v-icon small class="mr-2" @click="deleteItemWithPassword(item)" title="Cancella l'offerta">mdi-delete</v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="offerteSelected">
        <v-tabs dense v-model="tab[item.codice]">
          <v-tab key="datiGenerali" class="offerteSelected">Dati generali</v-tab>
          <v-tab key="periodi" class="offerteSelected">Periodi</v-tab>
          <v-tab key="categorie" v-if="item.tipoOfferta === 'categoria'" class="offerteSelected">Categoria</v-tab>
          <v-tab key="prodotti" v-if="item.tipoOfferta === 'prodotto'" class="offerteSelected">Prodotti</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab[item.codice]">
          <v-tab-item key="datiGenerali">
            <dati-generali :dati="item" :refresh="trigRefresh" @salva="salvaOfferte"/>
          </v-tab-item>
          <v-tab-item key="periodi">
            <periodi :dati="item" :refresh="trigRefresh" @salva="salvaOfferte"/>
          </v-tab-item>
          <v-tab-item key="categorie" v-if="item.tipoOfferta === 'categoria'">
            <categorie :dati="item" :refresh="trigRefresh" @salva="salvaOfferte"/>
          </v-tab-item>
          <v-tab-item key="prodotti" v-if="item.tipoOfferta === 'prodotto'">
            <prodotti :dati="item" :refresh="trigRefresh" @salva="salvaOfferte"/>
          </v-tab-item>  
        </v-tabs-items>
      </td>
    </template>        
    </v-data-table>
  </div>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import DialogErrore from '@/components/dialogErrore'
  // import Filtri from './filtri'
  import DatiGenerali from './elementi/datiGenerali'
  import Periodi from './elementi/periodi'
  import Categorie from './elementi/categorie'
  import Prodotti from './elementi/prodotti'
  import configurazioni from '@/services/configurazioniService.js'

  export default {
    components: {
      DialogErrore,
      // Filtri,
      DatiGenerali,
      Periodi,
      Categorie,
      Prodotti
    },
    mixins: [verificaLicenza],
    data () {
      return {
        totaleOfferte: 0,
        offerte: [],
        selected: [],
        loading: true,
        options: { itemsPerPage: 50 },
        headersDefault: [ // Caricato se non ci sono impostazioni diverse nel DB
          { text: 'Codice', value: 'codice', align: 'start' },
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Scontrino', value: 'descrizioneScontrino' },
          { text: 'Attiva', value: 'attiva' },
          { text: 'Dalla data', value: 'dataDa' },
          { text: 'Alla data', value: 'dataA' },
          { text: 'Tipologia', value: 'tipoOfferta', align: 'start' },
          { text: 'Qta Minima', value: 'quantitaMinima', align: 'end' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        headersBase: [
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        headersSpeciali: [
          { text: '', value: 'speciali', width: 80 }
        ],        
        headersBO: [],
        dialogErrore: false,
        dialogDelete: false,
        dialogECommerce: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        defaultItemArticolo: null,
        filtri: {
          tipoItem: 'PRODOTTO',
          testo: '',
          marchio: [],
          variante1: [],
          variante2: [],
          stagione: [],
          categoria1: [],
          categoria2: []   
        },
        expanded: [],
        singleExpand: false,
        tab: {},
        trigRefresh: 0,
        usaTagliaColore: false,
        usaLotti: false,
        usaDistintaBase: false,
        usaVariazioni: false,
        codiceCancellazione: '0000',
        moduloECommerce: false,
        moduloLotti: false
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Offerta' : 'Modifica Offerta'
      },
      offerteSorted() {
        const els = this.offerte
        if (this.options.sortBy && this.options.sortBy.length > 0) {
          return els
        } else {
          const elSorted = els
          return elSorted
        }
      },
      headers() {
        return this.headersDefault
      },
      magazziniMultipli() {
        return this.$store.getters['magazzini/magazziniMultipli']
      },
      magazzinoSelezionato() {
        return this.$store.getters['magazzini/codiceMagazzino']
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },
    async created() {
      this.defaultItem = {
        codice: '',
        descrizione: '',
        descrizioneScontrino: '',
        attiva: false,
        soloFidelity: false,
        dataDa: null,
        dataA: null,
        orari: null,
        tipoOfferta: 'prodotto',
        campoVerifica: '',
        valori: [],
        scontoPercentuale: 0,
        scontoEuro: 0,
        quantitaMinima: 1,
        articoli: []
      }
      this.defaultItemArticolo = {
        id: '',
        codice: '',
        prezzo: 0,
        scontoPercentuale: 15,
        scontoEuro: 0
      }
      /* 
        const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
        this.usaTagliaColore = backoffice.usaTagliaColore || false
        this.codiceCancellazione = backoffice.codiceCancellazione || '0000'
      */
    },
    async mounted () {
      await this.gestioneToken()
    },
    methods: {      
      async getDataFromApi() {
        try {
          this.loading = true

          this.offerte = await configurazioni.getConfigurazione('offerte', 'elenco')
          this.totaleOfferte = this.offerte.length
        } catch(err) {
          this.offerte = []
          this.totaleOfferte = 0
        } finally {
          this.loading = false
        }
      },
      async onNuovoOfferta() {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)))
        let na = _.cloneDeep(this.defaultItem)
        na.codice = await configurazioni.getNumeratore('offerta', true)
        this.offerte.push(na)
      },
      editItem(item) {
        this.editedIndex = this.offerte.indexOf(item)
        this.editedItem = Object.assign({}, item)
      },
      duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        this.editedItem.barcode = []
        this.editedItem.ricercaBarcode = ''
        delete this.editedItem._rev
      },
      deleteItemWithPassword(item) {
        if (prompt('inserire codice per cancellazione') === this.codiceCancellazione) {
          this.deleteItem(item)
        }
      },
      deleteItem (item) {
        this.editedIndex = this.offerte.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        this.offerte.splice(this.editedIndex, 1)
        await this.salvaOfferte()
        this.closeDelete()
      },

      close() {
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async salvaOfferte() {
        this.loading = true
        let offerte = await configurazioni.getConfigurazione('offerte')
        offerte.elenco = this.offerte
        await configurazioni.modificaConfigurazione(offerte)
        this.loading = false          
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  {
    box-shadow: none !important;
  }
    td.offerteSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
